var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Home"}},[_c('div',{staticClass:"home-Activity"},[_c('Activity')],1),_c('div',{staticClass:"home-news"},[_c('News',{attrs:{"newest":true}})],1),_c('div',{staticClass:"home-all-overview"},[_c('div',{staticClass:"top title components"},[_vm._v("全网概览")]),_c('div',{staticClass:"bottom content"},[_c('Overview')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }